current_id = undefined
current_page = null
questionID = 'NULL'
editRowId = null
rotateAngleValue = 0
rotating = false
imageNos = new Array

### The Header Page for a form ###

headerPage = null
vectorLayer = null
portalEditEntryTime = null
portalEditTime = null
portalEditTimeUpdate = null
uploadPartOf = new Array
# IDs of Part-of Questionnaire in a form type.
makeDatepicker = new Array
passkeychange = false

trim_name = (str) ->
	str.replace /^\s+|\s+$/g, ''

#Make sure that textBox only contain number

checkAccountName = (textBox) ->
	regex = new RegExp('^[a-z][a-z0-9_]*$')
	while textBox.value.length > 0 and !regex.test(textBox.value)
		textBox.value = textBox.value.substring(0, textBox.value.length - 1)
	textBox.value = trim_name(textBox.value)
	return

#Edit part of question

EditPartOf = (id, rowid) ->
	objPOI = getPOIByID(id)
	instance = objPOI.instance
	tempArray = new Array
	instance.temp = []
	for key of instance.row_id1
		if instance.row_id1[key] == rowid
			tempInstance = new Instance
			i = 0
			while i < instance.pages.length
				tempPage = new Pages
				curPage = instance.pages[i]
				tempPage.name = curPage.name
				tempPage.pageNo = curPage.pageNo
				tempInstance.pages[i] = tempPage
				questions = curPage.questions
				j = 0
				while j < questions.length
					qn = new Questions
					qn.id = questions[j].id
					qn.inVisible = questions[j].inVisible
					qn.type = questions[j].type
					qn.text = questions[j].text
					if qn.id == 'Name'
						qn.value = questions[j].ans[key]
						tempKey = arrayContains(tempArray, qn.value)
						if tempKey == -1
							tempInstance.name[0] = qn.value
					else
						qn.value = questions[j].ans[key]
					tempArray.push qn.value
					tempPage.questions.push qn
					j++
				i++
			if tempInstance.name[0] != undefined
				instance.temp.push tempInstance
	return

###*
	Saved a Part-of page data temporarily when editing.
###

savePartOfData = (id, p) ->
	`var j`
	`var question`
	`var value`
	if p == -1
		return
	instance = POI[id].instance
	page = instance.pages[p]
	j = 0
	while j < page.questions.length
		question = page.questions[j]
		setQuestionValue question, id
		j++
	if headerPage != null and headerPage != undefined and current_page == 1
		j = 0
		while j < headerPage.questions.length
			question = headerPage.questions[j]
			if question.type == 'BooleanQuestion' or question.type == 'SelectOneQuestion' or question.type == 'SelectMultipleQuestion'
				if document.getElementsByName(question.id) != null
					value = getRadioValue(question.id)
					question.value = value
			else if document.getElementById(question.id + '_' + id) != null
				value = document.getElementById(question.id + '_' + id).value
				question.value = value
			j++
	return

###*
	Invoked after a form has been selected on the selection box.
###

setPartOfFormValues = (id) ->
	`var j`
	p = 0
	instance = POI[id].instance
	questionnaireHTML = ''
	page = instance.pages[p]
	if page == undefined
		return
	j = 0
	while j < page.questions.length
		qn = page.questions[j]
		questionHtml = createQuestion(qn, false, id)
		questionnaireHTML += questionHtml
		j++
	if p + 1 <= instance.pages.length
		questionnaireHTML += '<div class="questionDiv">'
		if p > 0 and headerPage == null or headerPage != null and p > 1
			questionnaireHTML += '<button class="button-blue pointer" onclick="addPartOfPage(' + p - 1 + ', "' + id + '", ' + p + ')">Previous Page</button>'
		if p + 1 < instance.pages.length
			questionnaireHTML += '<button class="button-blue pointer" onclick="addPartOfPage(' + p + 1 + ', "' + id + ', ' + p + '")">Next Page</button>'
		questionnaireHTML += '</div>'
	else
	document.getElementById('partOfContent_' + id).innerHTML = questionnaireHTML
	temp = instance.temp
	pages = temp[document.getElementById('currentIndex').value].pages[p]
	questions = pages.questions
	j = 0
	while j < questions.length
		qst = questions[j]
		if document.getElementById(qst.id + '_' + id) != null
			if (document.getElementById(qst.id + '_' + id) != null or document.getElementsByName(qst.id) != null) and qst.value != undefined and qst.value != ''
				value = ''
				if qst.value == null or qst.value == undefined or qst.value == ''
					value = qst.defaultValue
				else
					value = qst.value
				if qst.type == 'BooleanQuestion' or qst.type == 'SelectOneQuestion'
					setRadioValue qst.id, value
				else if qst.type == 'SelectMultipleQuestion'
					setCheckBoxValue qst.id, qst.value
				else
					document.getElementById(qst.id + '_' + id).value = value
		j++
	return

#Loops through the elements defined in makedatapicker array and make them datapicker

loadDatePicker = ->
	i = 0
	while i < makeDatepicker.length
		$('#' + makeDatepicker[i]).datepicker
			changeMonth: true
			changeYear: true
			numberOfMonths: 1
			dateFormat: 'yy-mm-dd'
		i++
	makeDatepicker = []
	datePickerCount = 0
	datePickerCountPartOf = 0
	return

updateEditTime = ->
	portalEditTime = portalEditTime + 1
	return

resetForm = ->
	instance = POI[current_id].instance
	i = 0
	while i < instance.pages.length
		page = instance.pages[i]
		j = 0
		while j < page.questions.length
			page.questions[j].value = ''
			if document.getElementById(page.questions[j].id + '_' + current_id) != null
				document.getElementById(page.questions[j].id + '_' + current_id).value = ''
			j++
		i++
	if document.getElementById('tabs_' + current_id) != null
		document.getElementById('tabs_' + current_id).id = 'tabs'
	return

downloadData = ->
	window.open baseUrl + 'app/export/' + document.getElementById('exportPOIName').value + '/excel', '_blank'
	return

toogleSubQuestion = (div_id, value, questionId) ->
	buttons = document.getElementsByName(questionId)
	i = 0
	while i < buttons.length
		if buttons[i].checked and buttons[i].value == value
			$('.' + div_id).show()
			return
		else if !buttons[i].checked and buttons[i].value == value
			$('.' + div_id).hide()
			return
		i++
	return

hideSubQuestion = (value, questionId) ->
	instance = POI[current_id].instance
	i = 0
	while i < instance.pages.length
		page = instance.pages[i]
		j = 0
		while j < page.questions.length
			question = page.questions[j]
			if question.id == questionId
				opts = question.options
				actions = question.action
				t = 0
				while t < opts.length
					if actions[opts[t]] != undefined and opts[t] != value
						sq = actions[opts[t]]
						q = 0
						while q < sq.length
							resetSubQuestions sq[q]
							q++
						hideSubQuestions question.id + '_' + opts[t]
					t++
			j++
		i++
	return

resetSubQuestions = (question) ->
	question.value = ''
	if document.getElementById(question.id) == undefined
		return
	document.getElementById(question.id).value = ''
	if question.type == 'BooleanQuestion' or question.type == 'SelectOneQuestion'
		setRadioValue question.id, ''
	else if question.type == 'SelectMultipleQuestion'
		setCheckBoxValue question.id, ''
	opts = question.options
	actions = question.action
	t = 0
	while t < opts.length
		if actions[opts[t]] != undefined and opts[t] != value
			sq = actions[opts[t]]
			q = 0
			while q < sq.length
				resetSubQuestions sq[q]
				q++
		t++
	return

locationChanged = (locationId, level, id) ->
	childLocationId = ''
	if level == 0
		childLocationId = 'Location2'
	else if level == 1
		childLocationId = 'Location3'
	else if level == 2
		childLocationId = 'Location4'
	else if level == 3
		return
	childLocationId += '_' + id
	select = document.getElementById(childLocationId)
	if select != null
		value = document.getElementById(locationId + '_' + id).value
		removeAllOptions select
		select.options[select.options.length] = new Option('Select One', 'NULL')
		i = 0
		while i < locations.length
			if locations[i].parent == value
				select.options[select.options.length] = new Option(locations[i].title, locations[i].key)
			i++
	return

removeAllOptions = (selectbox) ->
	i = undefined
	i = selectbox.options.length - 1
	while i >= 0
		selectbox.remove i
		i--
	return

getRadioValue = (name) ->
	value = ''
	buttons = document.getElementsByName(name)
	#var buttons = document.elements.sadrFormInput.'data[Sadr][gender]';
	checked = false
	i = 0
	while i < buttons.length
		if buttons[i].checked
			if value != ''
				value += ','
			value += buttons[i].value
		i++
	value

getRadioButtonValue = (name) ->
	value = ''
	buttons = document.getElementsByName(name)
	#var buttons = document.elements.sadrFormInput.'data[Sadr][gender]';
	checked = false
	i = 0
	while i < buttons.length
		if buttons[i].checked
			value += buttons[i].value
			return value
		i++
	value

setRadioValue = (name, value) ->
	buttons = document.getElementsByName(name)
	checked = false
	i = 0
	while i < buttons.length
		if buttons[i].value == value
			buttons[i].checked = true
		else
			buttons[i].checked = false
		i++
	return

setCheckBoxValue = (name, value) ->
	buttons = document.getElementsByName(name)
	v = value.split(',')
	checked = false
	i = 0
	while i < buttons.length
		if v.length > 0
			j = 0
			while j < v.length
				if v[j] == buttons[i].value
					buttons[i].checked = true
				else
					buttons[i].checked = false
				j++
		else
			buttons[i].checked = false
		i++
	return

setLocationHieararchyData = ->
	`var l`
	`var l`
	`var l`
	instance = POI[current_id].instance
	locs = new Array
	i = 0
	while i < instance.pages.length
		page = instance.pages[i]
		j = 0
		while j < page.questions.length
			question = page.questions[j]
			if question.id == 'Location1'
				locs[1] = question
			else if question.id == 'Location2'
				locs[2] = question
			else if question.id == 'Location3'
				locs[3] = question
			else if question.id == 'Location4'
				locs[4] = question
			j++
		i++
	if locs[4] != undefined and locs[4].value != undefined and locs[4].value != ''
		l = locs[4]
		setLocation l.value, 4, locs
	else if locs[3] != undefined and locs[3].value != undefined and locs[3].value != ''
		l = locs[3]
		setLocation l.value, 3, locs
	else if locs[2] != undefined and locs[2].value != undefined and locs[2].value != ''
		l = locs[2]
		setLocation l.value, 2, locs
	else if locs[1] != undefined and locs[1].value != undefined and locs[1].value != ''
		l = locs[1]
		setLocation l.value, 1, locs
	return

getParent = (id) ->
	i = 0
	while i < locations.length
		if locations[i].key == id
			return locations[i].parent
		i++
	''

setLocation = (id, level, locs) ->
	nid = getParent(id)
	if nid == -1 or nid == ''
		return
	else
		locs[level - 1].value = nid
		setLocation nid, level - 1, locs
	return

getTableQuestionList = (temp, row_id, rel, type) ->
	`var j`
	`var question`
	`var value`
	#var jsonText = "{  \"questionList\" : [ ";
	jsonText = ''
	resp = new Array
	x = 0
	#Loop for table question
	j = 0
	while j < temp.questions.length
		question = temp.questions[j]
		if question.id == 'ID'
			tempID = question.value
			resp[0] = tempID
		value = 'NULL'
		#if(question.type == 'Location1Question' || question.type == 'Location2Question'|| question.type == 'Location3Question'|| question.type == 'Location4Question'|| question.type == 'IntQuestion') {
		if question.type == 'IntQuestion'
			value = '0'
		if question.id == 'countQuestion'
			value = 1
		if question.id == 'portalEditEntry'
			value = portalEditEntryTime.getTime()
		if question.type == 'IntQuestion' and value == 'NULL'
			value = 0
		if question.value != undefined and question.value != '' and question.value != '  -  '
			value = question.value
			value = value.replace('\\', '\\\\')
		if question.type == 'PicturesQuestion'
			j++
			continue
		if question.id == 'user_id' or question.id == 'group_id' or question.id == 'modified' or question.id == 'ID'
			j++
			continue
		if x == 0
			x++
			#jsonText += "{\"fieldName\":\"" + question.id +"\", \"answer\":\"" + value +"\"}";
			jsonText += '"' + question.id + '":"' + value + '",'
		else
			#jsonText += ",{\"fieldName\":\"" + question.id +"\",	\"answer\":\"" + value +"\"}";
			jsonText += '"' + question.id + '":"' + value + '",'
		jsonText += getQuestionValue(question)
		j++
	#Loop for part_of question
	i = 0
	while i < temp.pages.length
		page = temp.pages[i]
		j = 0
		while j < page.questions.length
			if page.questions[j].id == 'row_id1'
				j++
				continue
			question = page.questions[j]
			if question.id == 'ID'
				questionID = question.value
				#continue;
			if question.type == 'PicturesQuestion'
				j++
				continue
			if question.id == 'user_id' or question.id == 'group_id' or question.id == 'modified'
				j++
				continue
			value = 'NULL'
			#if(question.type == 'Location1Question' || question.type == 'Location2Question'|| question.type == 'Location3Question'|| question.type == 'Location4Question'|| question.type == 'IntQuestion') {
			if question.type == 'IntQuestion'
				value = '0'
			if question.value != undefined and question.value != ''
				value = question.value
				if value != parseInt(value)
					value = value.replace('\\', '\\\\')
			if question.id == 'countQuestion'
				value = 1
			if question.id == 'portalEditEntry'
				value = portalEditEntryTime.getTime()
			if question.type == 'IntQuestion' and value == 'NULL'
				value = 0
			if x == 0
				x++
				#jsonText += "{\"fieldName\":\"" + question.id +"\", \"answer\":\"" + value +"\"}";
				jsonText += jsonText += '"' + question.id + '":"' + value + '",'
			else
				#jsonText += ",{\"fieldName\":\"" + question.id +"\",	\"answer\":\"" + value +"\"}";
				jsonText += '"' + question.id + '":"' + value + '",'
			jsonText += getQuestionValue(question)
			j++
		i++
	#jsonText += "], \"relation\" : { \"id\" : \"" + rel + "\", \"row_id1\" : \"" + row_id + "\" , \"row_id2\" : \"0\" , \"type\" : \"" + type + "\"}";
	#jsonText += "}";
	resp[1] = jsonText
	resp

rotateCW = (row_id, id) ->
	if rotating
		return
	rotateAngleValue = 90
	div = document.getElementById('image' + currentImageIndex).name
	if isS3Image(row_id, id)
		rotateS3Image 'cw', row_id, div, id
	else
		rotateImage 'cw', row_id, div
	return

rotateCCW = (row_id, id) ->
	if rotating
		return
	div = document.getElementById('image' + currentImageIndex).name
	if isS3Image(row_id, id)
		rotateS3Image 'ccw', row_id, div, id
	else
		rotateImage 'ccw', row_id, div
	return

closeDownloads = ->
	$('#downloads-dialog').dialog 'close'
	return

rotateImage = (angle, row_id, data_no) ->
	document.getElementById('image_' + currentImageIndex).innerHTML = '<img src=\'' + image_res + 'ajax-loader.gif\'/><br/>Rotating Image...'
	rotating = true
	$.ajax
		type: 'POST'
		url: baseUrl + 'app/rotate/' + angle + '/' + row_id + '/' + data_no
		headers:
			'Content-Type': 'application/json'
			'userid': userName
			'key': pwrd
		success: (result) ->
			response = result
			return
		complete: ->
			if response.status == 'OK'
				rotating = false
				document.getElementById('image_' + currentImageIndex).innerHTML = '<img src="' + baseUrl + 'app/images/data/' + row_id + '?data_no=' + data_no + '&random=' + Math.floor(Math.random() * 9999999 + 1) + '&key=' + pwrd + '&userid=' + userName + '" alt="image' + currentImageIndex + '" id="image' + currentImageIndex + '" title="" name="' + data_no + '" style="" onclick="changeImage(\'' + currentImageIndex + '\')"/>'
			return
	return

rotateS3Image = (angle, row_id, data_no, id) ->
	document.getElementById('image_' + currentImageIndex).innerHTML = '<img src=\'' + image_res + 'ajax-loader.gif\'/><br/>Rotating Image...'
	rotating = true
	imageNo = POI[id].instance.imageNo[row_id]
	imagemime = imageNo[0][2]
	json = {}
	json['mimetype'] = imagemime
	$.ajax
		type: 'POST'
		data: json
		url: baseUrl + 'app/rotateS3Image/' + angle + '/' + row_id + '/' + data_no + '/' + db
		headers:
			'Content-Type': 'application/json'
			'userid': userName
			'key': pwrd
		success: (result) ->
			response = result
			return
		complete: ->
			if response.status == 'OK'
				rotating = false
				document.getElementById('image_' + currentImageIndex).innerHTML = '<img src="' + response.imageurl + '" alt="image' + currentImageIndex + '" id="image' + currentImageIndex + '" title="" name="' + data_no + '" style="" onclick="changeImage(\'' + currentImageIndex + '\')" width="500" height="400"/>'
			return
	return

isS3Image = (row_id, id) ->
	imageNo = POI[id].instance.imageNo[row_id]
	s = imageNo[0][2]
	if s.indexOf('_S3') != -1
		true
	else
		false

###*
	Setup cookie for selected locations, formtypes and current view
###

saveViewToCookie = ->
	# do nothing
	return

trim = (str) ->
	if str != null and str != undefined
		return str.replace(/^\s+|\s+$/g, '')
	return

deleteImageRow = (rowName) ->
	`var row`
	deleteIndex = -1
	table = document.getElementById('imagesTable')
	rowCount = table.rows.length
	i = 0
	while i < rowCount
		if i == 0
			i++
			continue
		row = table.rows[i]
		delButton = row.cells[1].childNodes[0]
		if delButton.name == rowName
			deleteIndex = i
		if i > rowName
			row = table.rows[i]
			x = 0
			while x < 2
				item = row.cells[x].childNodes[0]
				if x == 0
					item.setAttribute 'name', 'image' + i - 1 + ''
					item.setAttribute 'id', 'image' + i - 1 + ''
				else if x == 1
					item.setAttribute 'name', '' + i - 1 + ''
					item.setAttribute 'id', 'addImage' + i - 1 + ''
					item.setAttribute 'onclick', 'deleteImageRow(' + i - 1 + ')'
				x++
		i++
	if deleteIndex != -1
		table.deleteRow deleteIndex
	return

deleteImageQuestionRow = (rowName, q_id) ->
	`var row`
	deleteIndex = -1
	table = document.getElementById('imagesTable_' + q_id)
	rowCount = table.rows.length
	i = 0
	while i < rowCount
		if i == 0
			i++
			continue
		row = table.rows[i]
		delButton = row.cells[1].childNodes[0]
		if delButton.name == rowName
			deleteIndex = i
		if i > parseInt(rowName.substring(rowName.length - 1, rowName.length))
			row = table.rows[i]
			x = 0
			while x < 2
				item = row.cells[x].childNodes[0]
				if x == 0
					item.setAttribute 'name', 'image' + q_id + i - 1 + ''
					item.setAttribute 'id', 'image' + q_id + i - 1 + ''
				else if x == 1
					item.setAttribute 'name', '' + q_id + i - 1 + ''
					item.setAttribute 'id', 'addImage' + q_id + i - 1 + ''
					item.setAttribute 'onclick', 'deleteImageQuestionRow(' + q_id + i - 1 + ')'
				x++
		i++
	if deleteIndex != -1
		table.deleteRow deleteIndex
	return

removeTableRows = (id) ->
	table = document.getElementById(id)
	if table == undefined or table == null or table.rows.length == 0
		return
	rowCount = table.rows.length
	i = rowCount - 1
	while i >= 0
		table.deleteRow i
		i--
	return

addAttachImage = (question, formNo) ->
	response = ''
	response += '<br/><div class="' + question.id + '_image displayQuestionDiv hiddensq">'
	response += '<img src=\'' + baseUrl + 'app/images/instance/' + formNo + '?id=' + question.id + '&random=' + Math.floor(Math.random() * 9999999 + 1) + '&key=' + pwrd + '&userid=' + userName + '\' alt=\'\'/>'
	response += '</div>'
	response

hideAttachedImage = (id) ->
	if $('.' + id).hasClass('hiddensq')
		$('.' + id).removeClass 'hiddensq'
		$('.' + id).addClass 'shownsq'
		$('.' + id).show()
	else
		$('.' + id).removeClass 'shownsq'
		$('.' + id).addClass 'hiddensq'
		$('.' + id).hide()
	return

trim1 = (str) ->
	if str != undefined
		str.replace(/^\s\s*/, '').replace /\s\s*$/, ''
	else
		''

removeSpace = (str) ->
	removedSpace = str.replace(RegExp(' ', 'g'), '_')
	removedSpace = removedSpace.replace(/\(/g, '_')
	removedSpace = removedSpace.replace(/\)/g, '_')
	removedSpace = removedSpace.replace(/\//g, '_')
	removedSpace = removedSpace.replace(/\*/g, '_')
	removedSpace

###*
	Checks if the given value exists in the given Array
###

existsInArray = (array, value) ->
	for key of array
		if trim1(array[key]) == trim1(value)
			return true
	false

hideSqNew = (id, button) ->
	if $('#' + button).hasClass('subqDivCollapsed')
		$('#' + button).removeClass 'subqDivCollapsed'
		$('#' + button).addClass 'subqDivExpanded'
		$('.' + id).show()
	else
		$('#' + button).removeClass 'subqDivExpanded'
		$('#' + button).addClass 'subqDivCollapsed'
		$('.' + id).hide()
	return

removepwrd = ->
	if !document.getElementById('rememberme').checked
		if getCookie('rememberme')
			document.getElementById('passkey').value = ''
			document.getElementById('username').style.backgroundColor = '#FFFFFF'
			document.getElementById('passkey').style.backgroundColor = '#FFFFFF'
	return

onpasschange = ->
	passkeychange = true
	document.getElementById('username').style.backgroundColor = '#FFFFFF'
	document.getElementById('passkey').style.backgroundColor = '#FFFFFF'
	return

deleteRow = (rowName, id) ->
	`var row`
	try
		deleteIndex = -1
		table = document.getElementById('tab' + id)
		rowCount = table.rows.length
		i = 0
		while i < rowCount
			if i == 0
				i++
				continue
			row = table.rows[i]
			if i == rowName
				deleteIndex = i
			if i > rowName
				row = table.rows[i]
				j = 1
				x = 0
				while x < row.cells.length
					item = row.cells[x].childNodes[0]
					if x == 0
						item.innerHTML = i - 1
					else if x == row.cells.length - 1
						item.setAttribute 'onclick', 'deleteRow(' + i - 1 + ', ' + id + ')'
					else
						item.setAttribute 'id', item.getAttribute('name') + i - 1
						#item.setAttribute('name', (i - 1));
					x++
			i++
		if deleteIndex != -1
			table.deleteRow deleteIndex
	catch e
		alert e
	return

processSubQuestionsForReport = (subQs, srcSelect, chartid, rowandcolumn,questions,destSelect) ->
	if subQs.text != undefined
		#handle different chart types and question types
                criteriaquestion = document.getElementById("criteriaQuestion")
		if chartid == -1
			if subQs.type isnt 'SkipQuestion' and !subQs.inVisible and subQs.type isnt "Part_of_Question" and subQs.type isnt "TableQuestion" and subQs.type isnt "Label" and subQs.text isnt `undefined`
                            if questions isnt "" and questions.indexOf(subQs.id) isnt -1
                                destSelect.add new Option(subQs.text, subQs.id), null
                                destSelect.options[destSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + destSelect.options[destSelect.options.length - 1].innerHTML
                                criteriaquestion.add new Option(subQs.text, subQs.id), null if subQs.type is "CalculatedValueQuestion" or subQs.type is "StringQuestion" or subQs.type is "BooleanQuestion"
                                criteriaquestion.options[criteriaquestion.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + criteriaquestion.options[criteriaquestion.options.length - 1].innerHTML
                            else
                                srcSelect.add new Option(subQs.text, subQs.id), null
                                srcSelect.options[srcSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + srcSelect.options[srcSelect.options.length - 1].innerHTML
                                criteriaquestion.add new Option(subQs.text, subQs.id), null if subQs.type is "CalculatedValueQuestion" or subQs.type is "StringQuestion" or subQs.type is "BooleanQuestion"
                                criteriaquestion.options[criteriaquestion.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + criteriaquestion.options[criteriaquestion.options.length - 1].innerHTML
                	
		else if chartid == -2
                        if (subQs.type == 'IntQuestion' or subQs.type == 'FloatQuestion') and !subQs.inVisible and subQs.text isnt `undefined`
                            if questions isnt "" and questions.indexOf(subQs.id) isnt -1
                                destSelect.add new Option(subQs.text, subQs.id), null
                                destSelect.options[destSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + destSelect.options[destSelect.options.length - 1].innerHTML
                            else
                                srcSelect.add new Option(subQs.text, subQs.id), null
                                srcSelect.options[srcSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + srcSelect.options[srcSelect.options.length - 1].innerHTML
				
		else if chartid == 0 or chartid == 1 or chartid == 2
                        if (subQs.type == 'IntQuestion' or subQs.type == 'FloatQuestion' or subQs.type == 'SelectOneQuestion' or subQs.type == 'LikertScaleQuestion' or subQs.type == 'SelectMultipleQuestion' or subQs.type == 'BooleanQuestion') and !subQs.inVisible and subQs.text isnt `undefined`
                            if (subQs.type == 'IntQuestion' or subQs.type == 'FloatQuestion') and !subQs.inVisible
                                opt = new Option(subQs.text, subQs.id)
                                $(opt).attr 'isnumber', 'yes'
                            else
                                opt = new Option(subQs.text, subQs.id)
                                $(opt).attr 'isnumber', 'no'
                    
                            if questions isnt "" and questions.indexOf(subQs.id) isnt -1
                                destSelect.add opt, null
                                destSelect.options[destSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + destSelect.options[destSelect.options.length - 1].innerHTML
                            else
                                srcSelect.add opt, null
                                srcSelect.options[srcSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + srcSelect.options[srcSelect.options.length - 1].innerHTML
				
		else if chartid == 3
			if (subQs.type == 'SelectOneQuestion' or subQs.type == 'SelectMultipleQuestion' or subQs.type == 'BooleanQuestion' or subQs.type == 'LikertScaleQuestion') and !subQs.inVisible and subQs.text isnt `undefined`
                            if questions isnt "" and questions.indexOf(subQs.id) isnt -1
                                destSelect.add new Option(subQs.text, subQs.id), null
                                destSelect.options[destSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + destSelect.options[destSelect.options.length - 1].innerHTML
                            else
                                srcSelect.add new Option(subQs.text, subQs.id), null
                                srcSelect.options[srcSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + srcSelect.options[srcSelect.options.length - 1].innerHTML
				
	srcSelect

processSubQuestionsRowColumn = (qn, srcSelect, chartid, callNumber) ->
	if qn.hasSubquestions == true
		if callNumber == 1 and callNumber != 'undefined'
			questionindent = questionindent + '&nbsp;&nbsp;'
		else
			questionindent = ''
		x = 0
		while x < qn.options.length
			opt = qn.options[x]
			if qn.action[opt] != undefined
				subQ = qn.action[opt]
				j = 0
				while j < subQ.length
					quest = subQ[j]
					if !quest.inVisible or quest.type != 'PicturesQuestion' or quest.type != 'Part_of_Question' or quest.type != 'TableQuestion' or quest.type == 'Label' or quest.type != 'HeaderQuestion'
						#srcSelect.add(new Option('Sub - '+qn.text+"/"+quest.text, quest.id), null);
						if quest.type != 'Label'
							if quest.type == 'SelectMultipleQuestion' or quest.type == 'SelectOneQuestion' or quest.type == 'BooleanQuestion'
								srcSelect.add new Option(qn.options[x] + ' - ' + quest.text, quest.id), null
								srcSelect.options[srcSelect.options.length - 1].innerHTML = questionindent + '&nbsp;&nbsp;' + srcSelect.options[srcSelect.options.length - 1].innerHTML
								srcSelect.addEventListener 'change', (e) ->
									srcSelect.title = srcSelect.value
									return
								if quest.hasSubquestions
									processSubQuestionsRowColumn quest, srcSelect, -1, 1
									questionindent = ''
								else
									questionindent = ''
					j++
			x++
	return

isNumberKey = (evt) ->
	charCode = if evt.which then evt.which else event.keyCode
	!(charCode > 31 and (charCode < 48 or charCode > 57))

changedLocationLevel = ->
	reportType = if document.getElementById('locationreport').checked then 1 else 0
	if reportType is 1
		$('#locationLevel').show()
		document.getElementById('locationLevel').disabled = false
	else
		$('#locationLevel').hide()
	return

validateEmail = (email) ->
	atpos = email.indexOf('@')
	dotpos = email.lastIndexOf('.')
	if atpos < 1 or dotpos < atpos + 2 or dotpos + 2 >= email.length
		false
	else
		true

### TODO: Delete code moved to RegisterView
registerUser = ->
	first_name = document.getElementById('first_name').value.trim()
	last_name = document.getElementById('last_name').value.trim()
	reg_mail = document.getElementById('reg_mail').value.trim()
	password = document.getElementById('pass').value.trim()
	confirm_pass = document.getElementById('confirm_pass').value.trim()
	country = document.getElementById('country').value.trim()
	phone_number = document.getElementById('phone_number').value.trim()
	organization = document.getElementById('organization').value.trim()
	demo_data = 0
	#var demo_data = document.getElementById('demo_data').checked ? '1' : 0; //no longer used
	if phone_number == null
		phone_number = '-'
	if first_name.length == 0
		alert 'Fill in your first name'
		document.getElementById('first_name').focus()
		return
	if last_name.length == 0
		alert 'Fill in your last name'
		document.getElementById('last_name').focus()
		return
	if organization.length == 0
		alert 'Fill in your Organization'
		document.getElementById('organization').focus()
		return
	if reg_mail.length == 0
		alert 'Fill in your email address'
		document.getElementById('reg_mail').focus()
		return
	if reg_mail.indexOf('tearfund.org') >= 0 or reg_mail.indexOf('plan-international.org') >= 0
		alert 'Your organization already has an existing account that you can use. \nPlease contact support@poimapper.com for more details.'
		return
	if !validateEmail(reg_mail)
		alert 'Please enter a valid e-mail address'
		return
	if password.length == 0 or confirm_pass.length == 0
		alert 'Define a password.'
		document.getElementById('pass').value = ''
		document.getElementById('confirm_pass').value = ''
		document.getElementById('pass').focus()
		return
	if password != confirm_pass
		alert 'The password fields do not match. Please enter passwords again.'
		document.getElementById('pass').value = ''
		document.getElementById('confirm_pass').value = ''
		document.getElementById('pass').focus()
		return
	showProgress()
	document.getElementById('progressMessage').innerHTML = 'Registering user...'
	reg_json = '{ "first_name" : "' + first_name + '" , "last_name" : "' + last_name + '" , "password" : "' + password + '", "reg_mail" : "' + reg_mail.toLowerCase() + '", "country" : "' + country + '", "phone_number" : "' + phone_number + '", "registration_from" : "' + registration_from + '" ,"organization" : "' + organization + '","demo_data" : "' + demo_data + '"}'
	$.ajax
		type: 'POST'
		data: reg_json
		url: baseUrl + 'app/register'
		headers:
			'Content-Type': 'application/json'
			'userid': userName
			'key': pwrd
		success: (result) ->
			if result.status == 'OK'
				window.location.href = '//' + window.location.host + '/thankyou.jsp'
			else
				alert result.message
			return
		complete: ->
			closeProgress()
			return
		error: ->
			closeProgress()
			return
	return
###

activateAccount = (activation_code) ->
	if activation_code.trim() != ''
		$.ajax
			type: 'POST'
			async: false
			url: '/json/app/activation/' + activation_code
			headers: 'Content-Type': 'application/json'
			success: (result) ->
				if result.status == 'OK'
					document.getElementById('activation_icon').innerHTML = '<img title=\'Activation Successful\' src=\'/res/images/green-tick.png\' width=\'50\' height=\'40\'/>'
					document.getElementById('activation_message').innerHTML = result.message
				else
					document.getElementById('activation_icon').innerHTML = '<img title=\'Activation Failed\' src=\'/res/images/error.png\' width=\'40\' height=\'40\'/>'
					document.getElementById('activation_message').innerHTML = result.message
				return
			complete: ->
			error: ->
	return

getURLParameter = (name) ->
	#var temp = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null;
	temp = decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) or [ '' ])[1])
	if temp != null and temp != "undefined"
		temp.replace(/\+/g, '%20')
	else
		temp = null
	temp

prepareScript = (script, varMap, questionSkipEval) ->
	hasUndefinedVar = false
	initPart = 'function f(){String.prototype.contains=function(str){var arr=this.split(\',\');return arr.indexOf(str)!==-1;};'
	varPart = ''
	#debug.log('question.js varMap: ' + JSON.stringify(varMap));
	i = 0
	while i < varMap.length
		curVar = varMap[i]
		varInput = $('#' + curVar.questionID)
		varValue = undefined
		if varInput == undefined
			# in some other page
			varValue = survey.handler.getResponseFromCurrentAnswer(curVar.questionID)
			if varValue == null
				# not shown in UI yet, so need to take default
				varValue = curVar.default
		else
			if document.getElementById(curVar.questionID + '_' + current_id).type == 'radio'
				# radiobuttons
				if !document.getElementsByClassName(curVar.questionID)[0].checked
					varValue = document.getElementsByClassName(curVar.questionID)[1].value
				else
					varValue = varValue = document.getElementsByClassName(curVar.questionID)[0].value
				if varValue == undefined
					# nothing selected
					varValue = ''
				varPart += 'var ' + curVar.varName + '=\'' + varValue + '\';'
			else if varInput.is('div')
				# checkboxes
				varValue = $.serializeSelections(survey.Question.getValue(survey.handler.getQuestionById(curVar.questionID), ''))
				varPart += 'var ' + curVar.varName + '=\'' + varValue + '\';'
			else if varInput.is('select')
				# boolean
				varValue = survey.Question.getValue(survey.handler.getQuestionById(curVar.questionID), '')
				if varValue != undefined
					varPart += 'var ' + curVar.varName + '=' + varValue + ';'
			else
				varValue = document.getElementById(curVar.questionID + '_' + current_id).value
				if varValue == undefined
					# UI not ready
					for key of questionSkipEval.ans
						`key = key`
						varValue = questionSkipEval.ans[key]
					if varValue == null
						# not shown in UI yet, so need to take default
						varValue = curVar.default
				if varValue == undefined or varValue == null or value == ''
					hasUndefinedVar = true
					break
				else if curVar.asString
					varPart += 'var ' + curVar.varName + '=\'' + varValue + '\';'
				else
					varPart += 'var ' + curVar.varName + '=' + varValue + ';'
		i++
	fullScript = undefined
	if script.indexOf('return ') == -1
		# if no return, then it must be just expression
		fullScript = initPart + varPart + 'return ' + script + ';};f();'
	else
		fullScript = initPart + varPart + script + '};f();'
	{
		hasUndefinedVar: hasUndefinedVar
		fullScript: fullScript
	}

createSkipQuestion = (questionSkipEval, questionSkip) ->
	questionSkip.script = fixScript(questionSkip.Script or questionSkip.script)
	varMap = getVarMapping(questionSkip.script, questionSkipEval)
	info = prepareScript(questionSkip.script, varMap, questionSkipEval)
	scriptValue = null
	if info.hasUndefinedVar == false
		#try {
		scriptValue = eval(info.fullScript)
		#} catch (Exception) {
		#scriptValue = null;
		#}
	subQOne = questionSkip.action['No'][0]
	subQTwo = questionSkip.action['Yes'][0]
	if scriptValue
		#$("#" + subQOne.id).hide();
		#$("#" + subQTwo.id).show();
		$('.' + subQOne.id).hide()
		$('.' + subQTwo.id).show()
	else
		#$("#" + subQOne.id).show();
		#$("#" + subQTwo.id).hide();
		$('.' + subQOne.id).show()
		$('.' + subQTwo.id).hide()
	skipSwitch = $('<div></div>',
		id: questionSkip.id
		class: 'containing-element').prop('id', questionSkip.id).data('scriptValue', scriptValue).data('varMap', varMap)
	# don't show anything if undefined variables
	#if (scriptValue !== null && checkSubQuestions(question) !== null) {
	#createSubQuestions(question, skipSwitch);
	#}
	if scriptValue != null
		#createQuestionDisplay(questionSkip,formNo, firstPage, id);
	else
	return

fixScript = (script) ->
	if script == undefined or script == null
		'return null;'
	else
		script.replaceAll('&gt;', '>').replaceAll '&lt;', '<'

replaceAll = (find, replace, str) ->
	str.replace new RegExp(find, 'g'), replace

getVarMapping = (script, qn) ->
	varNamePattern = /_[0-9a-zA-Z_$]*/g
	# variable names start with '_'
	varMap = []
	varName = undefined
	varNames = {}
	while (varName = varNamePattern.exec(script)) != null
		varName = varName + ''
		if varNames[varName] == undefined
			# only add once
			varNames[varName] = true
			#var question = survey.handler.getQuestionByVariableName(varName.substr(1));
			question = getQuestionbySPSSVariable(current_id, varName.substr(1))
			if question
				# check that this is correct variable name
				asString = undefined
				asString = !('FloatQuestion' == question.type or 'IntQuestion' == question.type or 'BooleanQuestion' == question.type)
				varMap.push
					varName: varName
					questionID: question.id
					default: question.defaultValue
					asString: asString
	varMap

evalElement = (elem, val) ->
	# only run scripts if value changed
	val = val or elem.val()
	if val != elem.data('oldValue')
		elem.data 'oldValue', val
		IDs = elem.data('evalIDs')
		if IDs
			# SkipQuestion
			i = 0
			while i < IDs.length
				qid = IDs[i]
				evalQuestion = survey.handler.getQuestionById(qid)
				if evalQuestion
					if evalQuestion.Script == undefined
						evalQuestion.Script = undefined
						# get rid of inspection warning
					else
						evalQuestionElement = $('#' + evalQuestion.ID)
						# check it is on screen (not in some other page)
						if evalQuestionElement != undefined
							info = prepareScript(evalQuestion.Script, evalQuestionElement.data('varMap'))
							scriptValue = null
							#debug.log('question.js: eval script ' + info.fullScript);
							if info.hasUndefinedVar == false
								try
									scriptValue = eval(info.fullScript)
								catch Exception
									scriptValue = null
							# check if changed
							oldScriptValue = evalQuestionElement.data('scriptValue')
							if scriptValue != oldScriptValue
								# change sub-questions
								evalQuestionElement.empty()
								evalQuestionElement.data 'scriptValue', scriptValue
								if scriptValue != null
									createSubQuestions evalQuestion, evalQuestionElement, false, true
				i++
		else
			# table column SUM or AVERAGE
			columnClass = elem.data('columnClass')
			table = elem.closest('table')
			value = table.find('#' + columnClass + '-value')
			sum = 0
			count = 0
			table.find('.' + columnClass).each ->
				count++
				if $(this).val() != ''
					sum += parseFloat($(this).val())
				return
			if elem.data('columnOperation') == 'SUM'
				value.html sum
			else
				if count > 0
					avg = sum / count
					if isInteger(avg)
						value.html avg
					else
						value.html toFixed(avg, 2)
				else
					value.html '-'
	return

### throws and error so commented it out as it seems not to make any sense anymore to keep it
function getQuestionbyQuestionID (poi_id,questionID) {
	 y = 0;
		while (y < POI[poi_id].instance.pages.length) {
			for(var j = 0; j < POI[poi_id].instance.pages[y].questions.length; j++) {
				var qn = POI[poi_id].instance.pages[y].questions[j];

				if(qn.id==questionID){
					return qn;
				}

				if(qn.hasSubquestions && qn.id !=questionID){
					subQ = qn.action["No"];
					if(subQ !='undefined'){
								i = 0;
								while (i < subQ.length) {
									qn=subQ[i];
									if(qn.id==questionID){
								return qn;
							}
									i++;
								}
					}
								subQ = qn.action["Yes"];
								if(subQ !='undefined'){
								i = 0;
								while (i < subQ.length) {
									qn=subQ[i];
									if(qn.id==questionID){
								return qn;
							}
									i++;
								}
								}
				}
			}
			y++;
		}
}
###

getQuestionbySPSSVariable = (poi_id, SPSSVariable) ->
	y = 0
	while y < POI[poi_id].instance.pages.length
		j = 0
		while j < POI[poi_id].instance.pages[y].questions.length
			qn = POI[poi_id].instance.pages[y].questions[j]
			if qn.spssvariable == SPSSVariable
				return qn
			if qn.hasSubquestions and qn.spssvariable != SPSSVariable
				subQ = qn.action['No']
				if subQ != 'undefined'
					i = 0
					while i < subQ.length
						qn = subQ[i]
						if qn.spssvariable == SPSSVariable
							return qn
						i++
				subQ = qn.action['Yes']
				if subQ != 'undefined'
					i = 0
					while i < subQ.length
						qn = subQ[i]
						if qn.spssvariable == SPSSVariable
							return qn
						i++
			j++
		y++
	return

getElementLeft = (elm) ->
	x = 0
	x = elm.offsetLeft
	elm = elm.offsetParent
	while elm != null
		x = parseInt(x) + parseInt(elm.offsetLeft)
		elm = elm.offsetParent
	x

getElementTop = (elm) ->
	y = 0
	y = elm.offsetTop
	elm = elm.offsetParent
	while elm != null
		y = parseInt(y) + parseInt(elm.offsetTop)
		elm = elm.offsetParent
	y

$ ->
	$('#downloads-dialog').dialog
		open: (event, ui) ->
		autoOpen: false
		height: 230
		width: 280
		modal: true
		position: 'center'
		buttons: 'Close': ->
			$(this).dialog 'close'
			return
		close: ->
			#$( this ).dialog( "close" );
			return
	return
$ ->
	$('#fromdate').datepicker
		changeMonth: true
		numberOfMonths: 1
		onSelect: (selectedDate) ->
			$('#todate').datepicker 'option', 'minDate', selectedDate
			return
	$('#todate').datepicker
		changeMonth: true
		numberOfMonths: 1
		onSelect: (selectedDate) ->
			$('#fromdate').datepicker 'option', 'maxDate', selectedDate
			return
	return
$ ->
	$('#progress-dialog').dialog
		open: (event, ui) ->
			$('a.ui-dialog-titlebar-close').hide()
			return
		autoOpen: false
		height: 120
		width: 250
		modal: true
		position: 'center'
		close: ->
			#$( this ).dialog( "close" );
			return
		closeOnEscape: false
	return
$ ->
	$('#formtype-dialog').dialog
		autoOpen: false
		height: 350
		width: 310
		modal: true
		position: 'center'
		buttons: {}
		close: ->
		closeOnEscape: false
	return

showUpgradeDialog = ->
	$('#upgrade-modal').modal 'show'

upgradeAccount = ->
	acc_name = undefined
	acc_package = undefined
	acc_pricing = undefined
	acc_organization = undefined
	upgrade_json = undefined
	acc_name = document.getElementById('acc_name').value.trim()
	acc_package = $("input:radio[name='acc_package']:checked").val()
	acc_pricing = $("input:radio[name='acc_pricing']:checked").val()
	acc_organization = document.getElementById('acc_organization').value.trim()

	if acc_organization.length == 0
		alert 'Fill in your organization\'s name'
		return
	if acc_name.length == 0
		alert 'Fill in your unique account name without capital letters, numbers and special characters'
		return
	if acc_package is undefined
		alert 'Select preferred Poimapper package'
		return
	if acc_pricing is undefined
		alert 'Select preferred Poimapper pricing plan'
		return
	showProgress()
	document.getElementById('progressMessage').innerHTML = 'Upgrading Account...'
	upgrade_json = '{ "acc_name" : "' + acc_name + '", "acc_package" : "' + acc_package + '", "acc_pricing" : "' + acc_pricing + '", "acc_organization" : "' + acc_organization + '" }'
	$.ajax
		type: 'POST'
		data: upgrade_json
		url: '/json/app/account/upgradeaccount/' + userID
		headers:
			'Content-Type': 'application/json'
			userid: userName
			key: pwrd
		success: (result) ->
			if result.status == 'OK'
				$('#upgrade-modal').hide()
				Logout()
				window.location.href = '//' + window.location.host + '/' + acc_name
			else
				alert result.message
				$('#upgrade-modal').modal 'hide'
				$('#upgrade-modal').hide()
				$("input:radio[name='acc_package']").prop('checked', false)
				$("input:radio[name='acc_pricing']").prop('checked', false)
				document.getElementById('acc_organization').value = ''
				document.getElementById('acc_name').value = ''
				return
			return
		complete: ->
			closeProgress()

questionindent = ''
opt = ''
$ ->
	$('#help-dialog').dialog
		open: (event, ui) ->
			$('a.ui-dialog-titlebar-close').show()
			return
		autoOpen: false
		height: 420
		width: 700
		modal: true
		position: 'center'
		buttons: {}
		close: ->
			#myPlayer.stopVideo();
			video = $('#helpvideoid').attr('src')
			$('#helpvideoid').attr 'src', ''
			$('#helpvideoid').attr 'src', video
			return
	return
$ ->
	$('#Quick-Guide-dialog').dialog
		open: (event, ui) ->
			$('a.ui-dialog-titlebar-close').show()
			return
		autoOpen: false
		height: 550
		width: 850
		modal: true
		position: 'center'
		buttons: {}
		close: ->
	return

String::replaceAll = (find, replace) ->
	str = this
	str.replace new RegExp(find.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), replace

$(document).on 'shown.bs.modal', '.modal', ->
	$(this).find('[autofocus]').focus()
	return
